import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import CustomCard from "../../components/CustomCard/CustomCard";
import SettlementTable from "./Components/SettlementTable";
import { getUnassignedTxn } from "../../redux/slices/settlementSlice";
import useSearchableTable from "../../hooks/useSearchableTable";
import TableHeader from "../../components/CustomTable/TableHeader";
import "./Settlements.scss";
import { capitalizeEntireWord } from "../../helpers/helpers";

const Settlement = () => {
  const dispatch = useDispatch();
  const { unassignedTxn } = useSelector((state) => state.settlement);
  const { searchText, setSearchText, filteredData } = useSearchableTable(unassignedTxn);
  const [columnControl, setColumnControl] = useState(null);

  useEffect(() => {
    dispatch(getUnassignedTxn());
  }, [dispatch]);

  return (
    <CustomCard>
      <TableHeader
        title={capitalizeEntireWord("Unassigned Transactions")}
        searchText={searchText}
        setSearchText={setSearchText}
        columnControl={columnControl}
      />
      <SettlementTable data={filteredData} onColumnControlChange={setColumnControl} />
    </CustomCard>
  );
};

export default Settlement;
